import { registerBuiltinComponents } from "../../components/builtin/register";
import { registerComponentEffect, registerReactComponentEffect } from "../../state/actions";
import {
  parseBreakpointsInput
} from "../../state/modules/breakpoints";
import { ComponentIcon } from "../../state/modules/components-meta";
import {
  configureStore,
  copyElementTree,
  getBreakpoints,
  getElementTreeTranslatableData,
  mergeElementTreeTranslatedData
} from "../../state/react-page";
class ReactRuntime {
  // TODO: the static methods here are deprecated and only keep here for backward-compatibility purpose.
  // We will remove them when we release a new breaking change.
  // ------------------ Deprecated API ------------------ //
  static store = configureStore();
  static registerComponent(component, {
    type,
    label,
    icon = ComponentIcon.Code,
    hidden = false,
    props
  }) {
    const unregisterComponent = this.store.dispatch(
      registerComponentEffect(type, { label, icon, hidden }, props ?? {})
    );
    const unregisterReactComponent = this.store.dispatch(
      registerReactComponentEffect(type, component)
    );
    return () => {
      unregisterComponent();
      unregisterReactComponent();
    };
  }
  static copyElementTree(elementTree, replacementContext) {
    return copyElementTree(this.store.getState(), elementTree, replacementContext);
  }
  static getBreakpoints() {
    return getBreakpoints(this.store.getState());
  }
  static getTranslatableData(elementTree) {
    return getElementTreeTranslatableData(this.store.getState(), elementTree);
  }
  static mergeTranslatedData(elementTree, translatedData) {
    return mergeElementTreeTranslatedData(this.store.getState(), elementTree, translatedData);
  }
  // ------------------ Deprecated API ends here ------------------ //
  store;
  registerComponent(component, {
    type,
    label,
    icon = ComponentIcon.Cube,
    hidden = false,
    props
  }) {
    const unregisterComponent = this.store.dispatch(
      registerComponentEffect(type, { label, icon, hidden }, props ?? {})
    );
    const unregisterReactComponent = this.store.dispatch(
      registerReactComponentEffect(type, component)
    );
    return () => {
      unregisterComponent();
      unregisterReactComponent();
    };
  }
  copyElementTree(elementTree, replacementContext) {
    return copyElementTree(this.store.getState(), elementTree, replacementContext);
  }
  getBreakpoints() {
    return getBreakpoints(this.store.getState());
  }
  constructor({ breakpoints } = {}) {
    this.store = configureStore({
      breakpoints: breakpoints ? parseBreakpointsInput(breakpoints) : void 0
    });
    registerBuiltinComponents(this);
  }
  getTranslatableData(elementTree) {
    return getElementTreeTranslatableData(this.store.getState(), elementTree);
  }
  mergeTranslatedData(elementTree, translatedData) {
    return mergeElementTreeTranslatedData(this.store.getState(), elementTree, translatedData);
  }
}
registerBuiltinComponents(ReactRuntime);
export {
  ReactRuntime
};
//# sourceMappingURL=react-runtime.js.map